<template>
  <div class="my-published-books-area">
    <List :totalCount="totalCount" @flipPage="flipPage" :currentPage="currentPageNo">
      <template v-slot:listContent>
        <div v-if="isChart">
          <div v-show="booksCurrentSubAccount == ''" class="book-item add-book-div" @click="addBook">
            <img src="@imgs/add-book.png" alt="" />
            <div>创建新电子书刊</div>
          </div>
          <div class="book-item normal" v-for="(item, index) in books" v-bind:key="item.id">
            <img :src="item.cover" alt="" />
            <div class="get-book" @click="readBook(item.id, item.readModel, item.link, item)"></div>
            <div class="info-and-deal" v-show="!item.isReplacing && item.transitionStatus === 1">
              <div v-if="item.pdfReaderId" class="new-version-button" @click="toNewVersion(item.id)">体验新版本</div>
              <div class="title">{{ item.title }}</div>
              <div>{{ item.time }}</div>
              <div class="deal-btn-wrapper">
                <el-tooltip class="item" v-show="booksCurrentSubAccount == ''" effect="dark" content="阅读效果编辑" placement="bottom">
                  <img class="icon-style" src="@imgs/editPaperEffect.png" @click="editBook(item)" />
                </el-tooltip>
                <el-tooltip class="item" v-show="booksCurrentSubAccount == '' && item.readModel !== 1" effect="dark" content="数字内容编辑" placement="bottom">
                  <img class="icon-style" src="@imgs/editPaperArticle.png" @click="editBook(item, 'content')" />
                </el-tooltip>
                <el-tooltip class="item" effect="dark" v-show="booksCurrentSubAccount == ''" content="替换PDF" placement="bottom" v-if="item.readModel != 1 && item.readModel != 4">
                  <div class="replace" @click="replaceBook(item, index, item.merge === 1)">
                    <img class="icon-style" src="@imgs/replace.png" />
                    <Uploader
                      v-if="vipRight.bookSize && item.merge !== 1"
                      :index="index"
                      class="upload"
                      :ref="`replaceUploader${index}`"
                      :dropzoneOptions="dropzoneOptions"
                      @addFile="addFile($event, index)"
                      @uploadProgress="uploadProgress(arguments, index)"
                      @uploadSuccess="uploadSuccess(arguments, index)"
                      @uploadError="uploadError(arguments, index)"
                      @uploadCanceled="uploadCanceled($event, index)"
                      @uploadSending="uploadSending(arguments, index, item.id)"
                    >
                      <div class="button-upload"></div>
                    </Uploader>
                  </div>
                </el-tooltip>
                <el-tooltip class="item" v-show="booksCurrentSubAccount == ''" effect="dark" content="阅读数据" placement="bottom">
                  <img class="icon-style" src="@imgs/statistic-analysis.png" @click="goStatics(item.id, item.title)" />
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="下载" placement="bottom" v-if="item.downloadScope == 1">
                  <img class="icon-style" src="@imgs/download-icon.png" @click="goDownloadLocation(item.id, item.downloadFormat)" />
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="分享" placement="bottom">
                  <img class="icon-style" src="@imgs/share-icon.png" @click="shareBook(item.link, item.poster, item.posterPic, item.title, item.readModel)" />
                </el-tooltip>
                <el-tooltip v-show="booksCurrentSubAccount == '' || !isSubAccount" class="item" effect="dark" content="删除" placement="bottom">
                  <img class="icon-style" src="@imgs/delete-icon.png" @click="delBook(item.id)" />
                </el-tooltip>
              </div>
            </div>
            <div class="shade" v-show="item.isReplacing">
              <span>书刊替换中</span>
              <span>{{ item.replaceProgress }}%</span>
            </div>
            <div class="transfer" v-show="item.transitionStatus !== 1">
              <p>书刊正在转换中，预计需要1分钟，如封面未更新，请手动刷新当前页面</p>
            </div>
            <div class="qr-hover" v-show="index === currentHoverIndex">
              <vue-qr :text="item.link || ''" :size="120" :margin="5" />
            </div>
            <img
              class="qr-hover-button"
              v-show="!item.isReplacing && item.transitionStatus === 1"
              @mouseenter="currentHoverIndex = index"
              @mouseleave="currentHoverIndex = -1"
              src="@imgs/bookshelf/bookshelf_qrcode.png"
            />
          </div>
        </div>
        <div v-if="isList">
          <el-button @click="addBook">创建新电子书刊</el-button>
          <el-table class="paper-list" :data="books" border style="width: 100%" :header-cell-style="setHeaderCellStyle" :cell-style="setCellStyle">
            <el-table-column prop="title" show-overflow-tooltip label="名称" width="300"></el-table-column>
            <el-table-column prop="time" label="最近更新时间" width="240"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <div class="operate-wrapper">
                  <span @click="readBook(scope.row.id, scope.row.readModel, scope.row.link, scope.row)">预览</span>
                  <span v-show="booksCurrentSubAccount == ''" @click="editBook(scope.row)">阅读效果编辑</span>
                  <span v-show="booksCurrentSubAccount == '' && scope.row.readModel != 1" @click="editBook(scope.row, 'content')">数字内容编辑</span>
                  <span v-show="scope.row.downloadScope == 1" @click="goDownloadLocation(scope.row.id, scope.row.downloadFormat)">下载</span>
                  <span @click="shareBook(scope.row.link, scope.row.poster, scope.row.posterPic, scope.row.title, scope.row.readModel)">分享</span>
                  <span
                    class="replace"
                    v-show="booksCurrentSubAccount == '' && scope.row.readModel != 1 && scope.row.readModel != 4"
                    @click="replaceBook(scope.row, scope.$index, scope.row.merge === 1)"
                  >
                    <img v-if="scope.row.isReplacing" width="15" class="loading-icon" src="@imgs/bookshelf/listforreplace.png" alt="" />
                    <i v-else>替换PDF</i>
                    <Uploader
                      v-if="vipRight.bookSize && scope.row.merge !== 1"
                      :index="`list_${scope.$index}`"
                      class="upload"
                      :ref="`replaceUploader${scope.$index}`"
                      :dropzoneOptions="dropzoneOptions"
                      @addFile="addFile($event, scope.$index)"
                      @uploadProgress="uploadProgress(arguments, scope.$index)"
                      @uploadSuccess="uploadSuccess(arguments, scope.$index)"
                      @uploadError="uploadError(arguments, scope.$index)"
                      @uploadCanceled="uploadCanceled($event, scope.$index)"
                      @uploadSending="uploadSending(arguments, scope.$index, scope.row.id)"
                    >
                      <div class="button-upload"></div>
                    </Uploader>
                  </span>
                  <span v-show="booksCurrentSubAccount == ''" @click="goStatics(scope.row.id, scope.row.title)">阅读数据</span>
                  <span v-show="booksCurrentSubAccount == '' || !isSubAccount" @click="delBook(scope.row.id)">删除</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </template>
    </List>
    <TipDialog ref="deleteDialog" :dialogOptions="deleteDialogOptions" @clickCancel="deleteCancel" @clickConfirm="deleteConfrim"></TipDialog>
    <!-- 流式编辑弹窗 -->
    <el-dialog class="edit-dialog" center title="基础设置" :visible.sync="editDialogVisible" width="450px">
      <EditBase ref="editBase"></EditBase>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="editDialogCancel">取消</el-button>
        <el-button type="primary" @click="editDialogConfirm">保存</el-button>
      </div>
    </el-dialog>
    <Download ref="downloadLocation" :format="formatListArr" :id="downloadId" :has-article="hasListenList"></Download>
    <ShareDilalog ref="shareBookMsg" :qrObj="qrObj" :isInset="isInset"></ShareDilalog>
    <tip-dialog ref="spaceDialog" :dialogOptions="spaceDialogOptions" @clickConfirm="clickBuySpace"></tip-dialog>
    <batchUploader
      ref="batchPDFUpload"
      class="batch-upload-PDF"
      :type="'merge'"
      :totalCount="totalCount"
      @uploadProgress="uploadProgress()"
      @updateState="updateStateHandler"
      @toSpace="toSpace"
    ></batchUploader>
  </div>
</template>
<script>
import moment from 'moment'
import { mapState } from 'vuex'
import apis from '@api/getBook'
import setBook from '@api/setBook'
import Uploader from '@components/common/Uploader'
import batchUploader from '@components/uploadContent/batchPDFUpload'
import { isIllegalWord, setEncryption, sliceStrPicUrl, base64ToFile } from '@/utils'
import VueQr from 'vue-qr'
import getEpubPath from '@api/epub'
import Download from '@/components/books/components/download'
import ShareDilalog from '@/components/books/components/ShareDialog'
import TipDialog from '@components/common/TipDialog.vue'
import EditBase from '@components/editDrawer/edit/EditBase.vue'
import List from '@components/list/listFrame'
import { toPDF } from './form.js'

export default {
  name: 'BooksPublished',
  data() {
    return {
      currentHoverIndex: -1,
      replaceId: -1,
      replaceIndex: -1,
      currentPageNo: 1,
      scrollFlag: true,
      deleteId: -1,
      totalCount: 0,
      books: [],
      currentFile: null,
      readModel: null, //0代表版式、1代表流式、2代表兼容版式和流式、-2链接作品、-1专辑
      formatListArr: '',
      refreshListTimer: null,
      downloadId: '',
      hasListenList: false,
      isInset: true, //是否显示分享书刊嵌入代码
      qrObj: {
        value: '',
        iframeUrl: '',
        isShowPoster: 0
      },
      spaceDialogOptions: {
        // 弹框类型
        type: 'buySpace',
        // 弹框头部标题
        title: '提示',
        // 弹框内容
        tip: '您可用空间不足，请进行空间扩容'
      },
      deleteDialogOptions: {
        // 弹框类型
        type: 'delete',
        // 弹框头部标题
        title: '提示',
        // 弹框内容
        tip: '作品删除后无法恢复，是否确认删除？'
      },
      editDialogVisible: false, // 流式编辑窗口可见
      searchData: {
        queryTitle: '',
        createTimeEnd: '',
        createTimeStart: ''
      }
    }
  },
  components: {
    Uploader,
    VueQr,
    Download,
    ShareDilalog,
    TipDialog,
    EditBase,
    List,
    batchUploader
  },
  computed: {
    bookListPages() {
      return this.$store.state.manage.bookListPages
    },
    isSubAccount() {
      return this.$store.state.common.isSubAccount
    },
    userName() {
      return localStorage.getItem('username')
    },
    ...mapState('config', ['bookObj']),
    ...mapState('common', ['vipRight']),
    ...mapState('manage', ['booksCurrentSubAccount']),
    files() {
      return this.$store.state.book.batchPDFFiles
    },
    dropzoneOptions: {
      get() {
        // 开发环境的upload组件上传地址，不支持相对路径，只能取origin，生产环境取BASE_URL即可（两者实际值相同）
        const uploadBaseUrl = process.env.NODE_ENV === 'development' ? location.origin : window.PROJECT_CONFIG.BASE_URL
        let option = {
          url: uploadBaseUrl + '/cloudR/ebook/changePdfUpload',
          thumbnailWidth: 150,
          maxFiles: 1,
          maxFilesize: this.vipRight.bookSize,
          headers: { Accept: 'application/json, text/plain, */*' },
          chunking: true,
          forceChunking: true,
          chunkSize: 1024 * 1024,
          acceptedFiles: '.pdf,.PDF',
          duplicateCheck: true,
          autoProcessQueue: false,
          timeout: 10000000000000000,
          parallelUploads: 5
        }
        return option
      }
    },
    isChart() {
      return this.$store.state.common.isBookChart
    },
    isList() {
      return this.$store.state.common.isBookList
    }
  },
  methods: {
    //翻页
    flipPage(val) {
      this.getBooks(val)
      this.currentPageNo = val
    },
    //获取列表
    getBooks(pageNo) {
      this.$store.dispatch('common/login')
      let _this = this
      const param = {
        pageNo: pageNo,
        pageSize: 11,
        userName: this.booksCurrentSubAccount !== '' ? this.booksCurrentSubAccount : this.userName,
        title: this.searchData.queryTitle,
        createTimeStart: this.searchData.createTimeStart,
        createTimeEnd: this.searchData.createTimeEnd
      }
      apis.GetEbookByPage(param).then((res) => {
        if (res && res.status == 200 && res.data.page) {
          if (res.data.page.result.length) {
            _this.books = res.data.page.result.map((item, index) => {
              return {
                ...item,
                time: moment(item.createTime).format('YYYY-MM-DD HH:mm'),
                cover: item.readModel == 1 ? item.path + '/epub/Media/cover.jpg?v=' + new Date().getTime() : item.path + '/1.jpg?v=' + new Date().getTime(),
                isReplacing: false,
                replaceProgress: 0,
                link: ''
              }
            })
          } else {
            _this.books = []
          }
          _this.totalPages = res.data.page.totalPages
          _this.totalCount = res.data.page.totalCount
          if (_this.bookListPages == -1) {
            _this.$store.commit('manage/UPDATE_BOOK_LIST_PAGES', res.data.page.totalPages)
          }
          _this.getShareLink(_this.books)
        }
      })
    },
    addBook() {
      this.$router.push('/upload')
    },
    // 编辑图书
    editBook(item, type) {
      this.$store.commit('config/UPDATE_PAPERSTYLE', false)
      this.$store.commit('book/UPDATE_IS_BOOK', true)
      this.$store.commit('book/UPDATE_IS_PAPER', false)
      this.$store.dispatch('common/login')
      this.$store.commit('config/UPDATE_IS_PUBLISH', false)
      const { id, readModel, shareTitle, title, fileName, thumbnail, description } = item
      // 流式编辑打开弹窗
      if (readModel === 1) {
        apis.GetMobileBookDetails({ id }).then((res) => {
          if (res && res.data && res.status === 200) {
            const data = res.data.data
            const temp = {
              ...data,
              shareTitle: shareTitle || title || fileName,
              thumbnail: thumbnail || 'default',
              shareDesc: description || ''
            }
            this.$store.commit('config/UPDATE_BOOKOBJ', temp)
            this.editDialogVisible = true
            setTimeout(() => {
              this.$store.commit('book/UPDATE_BOOK_DATA', data)
            }, 0)
          }
        })
      } else {
        this.$store.commit('edit/UPDATE_LIST_TO_PAGE_NO', this.currentPageNo)
        this.$store.commit('book/UPDATE_ISSHOWWINDOW', 2)
        const encryption_id = setEncryption(id)
        this.$store.commit('config/UPDATE_BOOK_ID', id)
        this.$store.commit('edit/UPDATE_EDIT_HEADER_TYPE', 'editContent')
        if (type === 'content') {
          this.$router.push({ path: '/digital', query: { id: encryption_id, type: 'book' } })
        } else {
          this.$router.push({ path: '/book', query: { id: encryption_id } })
        }
        this.$store.commit('edit/UPDATE_EDIT_DRAWER_SHOW', true)
      }
    },
    // 关闭流式编辑
    editDialogCancel() {
      this.editDialogVisible = false
    },
    // 确认流式编辑
    async editDialogConfirm() {
      let publishDate = ''
      const { classify, issuingDate, publicationYear } = this.$refs.editBase
      // classify 1报纸 0期刊
      publishDate = classify ? issuingDate : publicationYear
      let { id, shareTitle, shareDesc, thumbnail } = this.bookObj
      // 若有上传图片
      if (thumbnail.includes('data:image')) {
        thumbnail = await this.picChangeUrl('thumbnail', thumbnail)
      } else {
        thumbnail = thumbnail === 'default' ? '' : sliceStrPicUrl(thumbnail)
      }
      setBook
        .editEbook({
          id,
          title: shareTitle,
          description: shareDesc,
          thumbnail,
          category: classify,
          publishDate
        })
        .then((res) => {
          if (res && res.data && res.status === 200 && res.data.code === 0) {
            this.editDialogVisible = false
            this.getBooks(this.currentPageNo)
          } else {
            this.$message({
              message: res.message || '保存失败',
              type: 'error'
            })
          }
        })
        .catch((err) => {
          this.$message({
            message: err.toString() || '保存失败',
            type: 'error'
          })
        })
    },
    // base64图片转换成文件
    async picChangeUrl(payload, data) {
      const result = await this.setBackgroundCustom(payload, data)
      if (result && result.data.code === 0) {
        return result.data.data
      }
    },
    async setBackgroundCustom(payload, data) {
      let params = new FormData()
      let waitData = null
      if (payload !== 'background') {
        waitData = base64ToFile(data) || ''
      } else {
        waitData = data
      }
      params.append('fieldName', payload)
      params.append(payload, waitData)
      return setBook.uploadPicture(params)
    },
    //查看图书 需要显示目录按钮
    async readBook(id, readModel, link, item) {
      if (readModel == 1) {
        window.open(link, '_blank')
      } else {
        const url = this.getBookLink(id)
        window.open(url, '_blank')
      }
    },
    getBookLink(id) {
      const encryption_id = setEncryption(id)
      this.$store.commit('config/UPDATE_BOOK_ID', id)
      this.$store.commit('edit/UPDATE_EDIT_HEADER_TYPE', 'catalog')
      let routeUrl = this.$router.resolve({
        path: '/book',
        query: { id: encryption_id }
      })
      return routeUrl.href
    },
    getEpubUrl(id) {
      // 跳转阅读器的链接
      const params = {
        epubId: id,
        userId: this.userName
      }
      return getEpubPath.getEpubPath(params)
    },
    getShareLink(arr) {
      arr.forEach(async (item) => {
        if (item.readModel != 1) {
          let url = this.getBookLink(item.id)
          this.$set(item, 'link', window.location.origin + url.replace('book', 'content'))
        } else {
          try {
            const epubUrl = await this.getEpubUrl(item.id)
            const rearSharp = /#*$/
            // 开发环境的epub是另一个前端本地项目地址，生产环境则是同一域名下
            const epubBaseUrl = window.location.protocol + (process.env.NODE_ENV === 'development' ? window.PROJECT_CONFIG.epub_url : window.PROJECT_CONFIG.BASE_URL)
            let url = `${epubBaseUrl}${epubUrl.data.url}&returnPath=${window.encodeURIComponent(window.location.href.replace(rearSharp, ''))}`
            this.$set(item, 'link', url)
          } catch (e) {
            console.log(e)
          }
        }
      })
    },
    //替换书刊
    replaceBook(item, index, isMerge) {
      this.replaceId = item.id
      this.replaceIndex = index
      if (isMerge) {
        this.$store.commit('config/UPDATE_BOOKOBJ', item)
        this.$refs.batchPDFUpload.upload()
      }
      // 缩略图模式 isMerge为false也能替换，列表模式也保持这个逻辑
      // this.$refs.batchPDFUpload.upload()
    },
    //---------替换上传----------
    addFile(file, index) {
      try {
        const i = `replaceUploader${index}`
        this.$store.dispatch('common/login')
        if (!isIllegalWord(file.name)) {
          setTimeout(() => {
            this.$set(this.books[index], 'isReplacing', true)
            if (Array.isArray(this.$refs[i])) {
              this.$refs[i][0].processQueue()
            } else {
              this.$refs[i].processQueue()
            }
          }, 50)
        } else {
          this.$refs[i][0].cancelUpload()
          this.$alert('文件名中含有特殊字符，请重新上传', '提示', {
            confirmButtonText: '确定'
          })
        }
      } catch (error) {
        console.log('addFile err', error)
      }
    },
    uploadSending(params, index, id) {
      //file, xhr, formData
      params[2].append('fileName', params[0].name)
      params[2].append('id', id)
    },
    uploadProgress(params, index) {
      //file, progress, bytesSent
      let percentage = 0
      if ((index || index === 0) && params) {
        percentage = Number(((params[2] / params[0].size) * 100).toFixed(2))
        this.books[index].replaceProgress = percentage >= 100 ? 99 : percentage
      } else {
        for (const i in this.files) {
          percentage += this.files[i].percentage
        }
        percentage = (percentage / this.files.length).toFixed(2)
        this.books[this.replaceIndex].replaceProgress = percentage >= 100 ? 99 : percentage
      }
    },
    uploadSuccess(params, index) {
      const i = `replaceUploader${index}`
      //file, response
      let file = params[0]
      if (this.uploadTimer) {
        clearTimeout(this.uploadTimer)
      }
      if (file.xhr.response) {
        let res = JSON.parse(file.xhr.response)
        if (res.code == 0) {
          this.$set(this.books[index], 'replaceProgress', 100)
          this.$set(this.books, index, res.data)
          this.$set(this.books[index], 'cover', res.data.path + '/1.jpg?v=' + new Date().getTime())
          this.$set(this.books[index], 'time', moment(res.data.createTime).format('YYYY-MM-DD HH:mm'))
          setTimeout(() => {
            this.$set(this.books[index], 'isReplacing', false)
            this.$set(this.books[index], 'replaceProgress', 0)
            this.getSpace()
            // this.$refs[i][0].removeAllFiles(true)
            this.getShareLink(this.books)
          }, 300)
        } else if (res.code == 1) {
          if (res.message.includes('请进行空间扩容')) {
            this.$refs.spaceDialog.visible = true
          } else {
            this.$alert(res.message, {
              confirmButtonText: '确定'
            })
          }
          this.books[index].isReplacing = false
          this.books[index].replaceProgress = 0
        }
      }
    },
    uploadError(params, index) {
      // file, message, xhr
      let message = params[1]
      // uploaderror Server responded with 0 code.
      // Upload canceled.
      if (message.startsWith('File is too big')) {
        this.$alert(`上传PDF文件大于${this.vipRight.bookSize}M，请重新上传`, '提示', {
          confirmButtonText: '确定'
        })
      } else if (message.startsWith("You can't upload files of this type")) {
        this.$alert('请上传pdf文件', '提示', {
          confirmButtonText: '确定'
        })
      } else if (message !== 'Upload canceled.') {
        this.$alert('您的作品内容较多，不能短时间内完成转换，请耐心等待，稍后刷新查看', '提示', {
          confirmButtonText: '确定'
        })
      }
      this.$nextTick(() => {
        this.uploadCanceled(null, index)
      })
    },
    uploadCanceled(file, index) {
      setTimeout(() => {
        this.books[index].isReplacing = false
        this.books[index].replaceProgress = 0
      }, 1000)
    },
    //---------删除---------
    delBook(id) {
      this.$store.dispatch('common/login')
      this.$refs.deleteDialog.visible = true
      this.deleteId = id
    },
    shareBook(link, poster, posterPic, title, readModel) {
      this.$refs.shareBookMsg.dialogVisible = true
      if (readModel == 1) {
        this.$store.commit('config/UPDATE_POSTERBG', '')
        this.$store.commit('config/UPDATE_POSTER', '')
      } else {
        this.$store.commit('config/UPDATE_POSTERBG', posterPic)
        this.$store.commit('config/UPDATE_POSTER', poster)
      }
      this.qrObj.value = link
      this.qrObj.iframeUrl = '<iframe src="' + this.qrObj.value + '" style="width:100%;height:99.5%"></iframe>'
      this.qrObj.isShowPoster = poster
      this.qrObj.title = title
    },
    deleteCancel() {
      this.$refs.deleteDialog.visible = false
    },
    deleteConfrim() {
      this.$refs.deleteDialog.visible = false
      let params = {
        ids: this.deleteId
      }
      apis.delBook(params).then((res) => {
        if (res.status == 200) {
          if (res.data) {
            this.$alert(res.data.msg, '提示', {
              confirmButtonText: '确定'
            })
            if (this.books.length === 1 && this.currentPageNo > 1) {
              this.currentPageNo--
            }
            this.getBooks(this.currentPageNo)
            this.getSpace()
          }
        }
      })
    },
    //已用容量
    getSpace() {
      this.$store.dispatch('manage/getSpace')
    },
    goStatics(id, title) {
      let workMsn = {
        id: id,
        name: title
      }
      let a = document.createElement('a')
      a.href = window.PROJECT_CONFIG.BASE_URL2 + '/statistics/index.html#/detailData?from=ebook&workMsn=' + JSON.stringify(workMsn)
      a.target = '_blank'
      a.click()
    },
    async goDownloadLocation(id, format) {
      this.formatListArr = format
      this.downloadId = id
      await apis.getArticleListByEpaperId({ epaperId: id, module: 'ebook' }).then((res) => {
        if (res && res.data && res.status === 200) {
          res.data.data.forEach((edition) => {
            if (edition.xiaoYangList && edition.xiaoYangList.length > 0) {
              this.hasListenList = true
            }
          })
        }
      })
      this.$refs.downloadLocation.dialogVisible = true
    },
    getBooksParsingStatus() {
      apis.getBooksParsingStatus().then((res) => {
        if (res.status === 200) {
          if (!res.data.data) {
            for (let i = 0; i < this.books.length; i++) {
              if (this.books[i].isReplacing) {
                this.refreshListTimer = setTimeout(() => {
                  this.getBooksParsingStatus()
                }, 10000)
                return
              }
            }
            clearTimeout(this.refreshListTimer)
            this.getBooks(this.currentPageNo)
          } else {
            this.refreshListTimer = setTimeout(() => {
              this.getBooksParsingStatus()
            }, 10000)
          }
        }
      })
    },
    clickBuySpace() {
      this.$router.push({
        path: '/openVIP',
        query: {
          dilatation: 1
        }
      })
    },
    // 体验PDF阅读器
    toNewVersion(id) {
      toPDF(id)
    },
    //替换合并pdf
    toSpace() {
      this.$refs.spaceDialog.visible = true
    },
    updateStateHandler(state) {
      if (state === 'batchUploading') {
        this.$set(this.books[this.replaceIndex], 'isReplacing', true)
      }
      if (state === 'done') {
        this.$router.push({ name: 'Upload', params: { to: 'PDFUpload', replaceId: this.replaceId } })
      }
    },
    setHeaderCellStyle() {
      return { 'background-color': '#fafafa', 'text-align': 'center', color: '#333' }
    },
    setCellStyle() {
      return 'text-align: center'
    }
  },
  mounted() {
    if (this.$route.query.sourceSite && this.$route.query.sourceSite == 1) {
      this.$alert('书刊转换中，转换完成后页面将自动刷新。', '提示', {
        confirmButtonText: '确定',
        callback: () => {
          window.location.href = window.location.href.replace('?sourceSite=1', '')
        }
      })
    }
    this.getBooksParsingStatus()
  },
  watch: {
    booksCurrentSubAccount() {
      this.getBooks(1)
    }
  },
  created() {
    if (this.$route.params.pageNo) {
      this.currentPageNo = this.$route.params.pageNo
      this.$route.params.pageNo = 1
    }
    this.getBooks(this.currentPageNo)
  },
  destroyed() {
    clearTimeout(this.refreshListTimer)
    this.currentPageNo = 1
  }
}
</script>
<style lang="scss">
.my-published-books-area {
  padding-bottom: 40px;
  .book-item {
    display: inline-block;
    vertical-align: top;
    width: 249px;
    height: 340px;
    border: 1px solid rgba(232, 232, 232, 1);
    color: rgba(255, 255, 255, 0.8);
    margin-right: 10px;
    margin-bottom: 10px;
    position: relative;
    color: #fff;
    line-height: 20px;
    cursor: pointer;
    .shade {
      position: absolute;
      width: 100%;
      height: 100%;
      font-size: 14px;
      background: rgba(0, 0, 0, 0.5);
      top: 0;
      left: 0;
      cursor: default;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
    }
    .get-book {
      height: 280px;
      width: 100%;
      position: absolute;
    }
    .info-and-deal {
      display: none;
      position: absolute;
      width: 100%;
      height: 80px;
      background: rgba(0, 0, 0, 0.5);
      bottom: 0;
      left: 0;
      padding: 2px 10px;
      // line-height: 21px;
      font-size: 14px;
      .title {
        width: 230px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .new-version-button {
        width: 72px;
        height: 26px;
        background-color: #df5813;
        border-radius: 3px;
        color: #fff;
        line-height: 24px;
        position: absolute;
        right: 9px;
        font-size: 12px;
        text-align: center;
        top: 10px;
      }
    }
    .qr-hover {
      background: rgba(0, 0, 0, 0.5);
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
    }
    .qr-hover-button {
      position: absolute;
      left: 21px;
      top: 21px;
    }
    .transfer {
      background: rgba(0, 0, 0, 0.5);
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      padding: 0 30px;
    }
    .deal-btn-wrapper {
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: space-around;
      .deal-btn {
        display: inline-block;
        padding: 5px 0px;
        width: 30%;
        text-align: center;
        border-radius: 6px;
        background: rgba(81, 81, 81, 1);
        margin-right: 6px;
        &.replace {
          position: relative;
          .upload {
            width: 100%;
            height: 100%;
            min-height: 100%;
            position: absolute;
            top: 0;
            opacity: 0;
          }
        }
      }
      .replace {
        position: relative;
        .upload {
          width: 100%;
          height: 100%;
          min-height: 100%;
          position: absolute;
          top: 0;
          opacity: 0;
          visibility: visible;
        }
      }
      .deals-btn {
        width: 25%;
        height: 30px;
        font-size: 14px;
      }
      .bg-yellow {
        background: rgba(223, 88, 19, 1);
      }
      .icon-style {
        width: 20px;
        height: 20px;
        display: block;
        position: static;
        top: 0;
        left: 0;
        transform: none;
      }
    }
  }
  .book-item:hover .info-and-deal {
    display: block;
  }
  .normal img {
    max-width: 100%;
    max-height: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .add-book-div {
    color: #000;
    padding: 150px 20px;
    text-align: center;
    img {
      margin-bottom: 16px;
    }
  }

  .page-component {
    position: fixed;
    background-color: #fff;
    width: calc(100% - 265px);
    bottom: 20px;
    right: 20px;
    left: 245px;
  }
  .edit-dialog {
    .el-dialog__body {
      padding: 25px 75px;
    }
  }
  .paper-list {
    margin-top: 20px;
    .operate-wrapper {
      span {
        cursor: pointer;
        color: #df5813;
        margin-right: 20px;
        i {
          font-style: normal;
        }
      }
      span:last-child {
        margin-right: 0;
      }
      .replace {
        position: relative;
        .upload {
          width: 100%;
          height: 100%;
          min-height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          opacity: 0;
          visibility: visible;
        }
      }
    }
    /* 定义加载图标样式 */
    .loading-icon {
      vertical-align: -2px;
      /* 添加动画 */
      animation: spin 1s linear infinite; /* 动画名称、持续时间、速度曲线、重复次数 */
    }

    /* 定义动画关键帧 */
    @keyframes spin {
      to {
        transform: rotate(360deg); /* 旋转360度，完成一次完整旋转 */
      }
    }
  }
}
</style>
